import { NormalSelectOptions } from "@app/components/select/select.type";
import { CommonType } from "./common.type";

export enum CampaignType {
  GIFT_BOOK = 1,
  GIFT_KAS = 2,
  GIFT_VIP = 3,
}

export const CampaignTypeOptions: NormalSelectOptions = [
  { label: "Campaign tặng sách", value: CampaignType.GIFT_BOOK },
  { label: "Campaign tặng kas", value: CampaignType.GIFT_KAS },
  { label: "Campaign tặng VIP", value: CampaignType.GIFT_VIP },
];

export interface AffiliateCampaign extends CommonType {
  id: number;
  userId: number;
  userFullName: string;
  userThumbnail: string;
  bookId: number;
  bookName: string;
  bookThumbnails: string[];
  content: string;
  type: number;
  kas?: number;
  vipTime?: number;
  thumbnail?: string;
  startDate: number | null;
  endDate: number | null;
  createdBy: number;
  createdDate: number;
  lastModifiedBy: number;
  lastModifiedDate: number;
  deleteFlag: boolean;
}

export interface CreateAffiliateCampaign {
  type: number;
  bookId?: number;
  content: string;
  kas?: number;
  vipTime?: number;
  thumbnail?: string;
  startDate: string | null;
  endDate: string | null;
}

export interface UpdateAffiliateCampaign {
  type: number;
  bookId?: number;
  content: string;
  kas?: number;
  vipTime?: number;
  thumbnail?: string;
  startDate: string | null;
  endDate: string | null;
}
